import classNames from "classnames";
import React, { FC, memo } from "react";

import { ODSIcon } from "../ODSIcons";
import { ODSRow } from "../ODSRow";
import { ODSText } from "../ODSText";
import { ODSSupportMessageProps } from "./ODSSupportMessage.types";
import { getSupportMessageIconName } from "./ODSSupportMessage.utils";

import "./css/index.css";

const ODSSupportMessage: FC<ODSSupportMessageProps> = ({
  className,
  type: typeProp = "informative",
  mode: modeProp = "informative",
  disabled = false,
  message: messageProp,
  helperText: helperTextProp,
  ...rest
}) => {
  const mode = modeProp ?? typeProp;
  const helperText = helperTextProp ?? messageProp;
  return (
    <ODSRow
      className={classNames(
        `ODSSupportMessage`,
        `ODSSupportMessage--mode-${mode}`,
        disabled && `ODSSupportMessage--disabled`,
        className
      )}
      {...rest}
    >
      <ODSIcon
        name={getSupportMessageIconName(mode)}
        className="ODSSupportMessage-Icon"
        aria-hidden={true}
      />

      {helperText && (
        <ODSText as="span" className="ODSSupportMessage-Label">
          {helperText}
        </ODSText>
      )}
    </ODSRow>
  );
};

export default memo(ODSSupportMessage);
